import { render } from "./PictureDetail.vue?vue&type=template&id=0c28965b"
import script from "./PictureDetail.vue?vue&type=script&lang=js"
export * from "./PictureDetail.vue?vue&type=script&lang=js"

import "./PictureDetail.vue?vue&type=style&index=0&id=0c28965b&lang=css"

import exportComponent from "D:\\JavaProject\\multilingual_corpus\\multilingual_corpus\\multilingual_corpus_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__